import React, { Fragment, useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  IconButton,
  Typography,
  MenuItem,
  ListItemText
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { FormQuestionSignature } from '../../proxy/proxy';

interface SignatureInputProps {
  order: number;
  currentFieldState: FormQuestionSignature;
  fieldStateChanged: (fieldState: any, order: number) => void;
  deleteEl: (order: number, id: string) => void;
  handleArrowUpClick: (order: number) => void;
  handleArrowDownClick: (order: number) => void;
  duplicateElement: (order: number) => void;
}

const SignatureInput: React.FC<SignatureInputProps> = ({
  order,
  currentFieldState,
  fieldStateChanged,
  deleteEl,
  duplicateElement,
  handleArrowDownClick,
  handleArrowUpClick
}) => {
  const [fieldState, setFieldState] = useState<FormQuestionSignature>(currentFieldState);

  useEffect(() => {
    fieldStateChanged(fieldState, order);
  }, [fieldState]);

  return (
    <Fragment>
      <Paper elevation={2}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingLeft: '20px',
            paddingRight: '20px',
            paddingTop: '10px',
            paddingBottom: '10px'
          }}
        >
          <Typography color="textPrimary" variant="h4">
            Signature question
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <FormControlLabel
              control={(
                <Switch
                  checked={fieldState.required || false}
                  onChange={() => {
                    setFieldState({ ...fieldState, required: !fieldState.required });
                  }}
                  name="required-field"
                  color="secondary"
                />
              )}
              label="Required"
              sx={{ ml: 2 }}
            />
            <IconButton
              sx={{
                borderRadius: '50%',
                padding: '10px',
                backgroundColor: '#f0f0f0',
                marginRight: '5px'
              }}
              onClick={() => handleArrowUpClick(order)}
            >
              <ArrowUpwardIcon sx={{ cursor: 'pointer' }} />
            </IconButton>
            <IconButton
              sx={{
                borderRadius: '50%',
                padding: '10px',
                backgroundColor: '#f0f0f0',
                marginRight: '5px'
              }}
              onClick={() => handleArrowDownClick(order)}
            >
              <ArrowDownwardIcon sx={{ cursor: 'pointer' }} />
            </IconButton>
            <IconButton
              sx={{
                borderRadius: '50%',
                padding: '10px',
                backgroundColor: '#f0f0f0',
                marginRight: '5px'
              }}
              onClick={() => deleteEl(order, currentFieldState.id)}
            >
              <DeleteIcon sx={{ cursor: 'pointer' }} color="primary" />
            </IconButton>
            <IconButton
              sx={{
                borderRadius: '50%',
                padding: '10px',
                backgroundColor: '#f0f0f0'
              }}
              onClick={() => duplicateElement(order)}
            >
              <ContentCopyIcon sx={{ cursor: 'pointer' }} color="primary" />
            </IconButton>
          </Box>
        </Box>
        <Box sx={{ p: 3, mb: 4 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                value={fieldState.title}
                variant="filled"
                label="Signature question title *"
                onChange={(e) => {
                  setFieldState({ ...fieldState, title: e.target.value });
                }}
                fullWidth
                sx={{ mb: 2 }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={fieldState.subTitle || ''}
                variant="filled"
                label="Signature question subtitle"
                onChange={(e) => {
                  setFieldState({ ...fieldState, subTitle: e.target.value });
                }}
                fullWidth
                sx={{ mb: 2 }}
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Fragment>
  );
};

export default SignatureInput;
